import {
  ServerSendEventHandler,
} from "@/models/ServerSendEvent/ServerSendEventHandler"

const message = new ServerSendEventHandler("message")

export default message
